<template>
  <div class="footer-bar-contact-form">

    <div class="contact-heading block-heading-font-style">{{ contactContent.heading }}</div>
    <div class="contact-subheading block-subheading-font-style">{{ contactContent.subheading }}</div>

    <form id="mm-contact-form" class="mm-contact-form" method="post">
      <input v-for="input in contactContent.formFields" :class="input.className" :type="input.type" :name="input.name" :placeholder="`${input.placeholder} (required)`" v-if="input.required" required>
      <input v-for="input in contactContent.formFields" :class="input.className" :type="input.type" :name="input.name" :placeholder="input.placeholder" v-if="!input.required">
      <input class="footer-bar-contact-form-submit" type="submit" name="" value="Submit">
    </form>

    <div id="mm-contact-form-success" class="mm-contact-form-success">{{ contactContent.successMessage }}</div>
  </div>
</template>

<script>

let formEmail = 'hello@mikmak.tv'

if (window.location.pathname.indexOf('customer_success_manager') != -1) formEmail = 'maorkwom'

const formUrl = `https://formspree.io/${formEmail}`

const handleFormData = (event) => {
  event.preventDefault();
  let formData = $('#mm-contact-form').serializeArray()
  submitForm(formData)
}

const submitForm = (formData) => {

  if (window.mmProductInterests) {
    formData.push({
      name: 'product_interests',
      value: window.mmProductInterests.join(', ')
    })
  }

  $.ajax({
      url: formUrl,
      method: "POST",
      data: formData,
      dataType: "json"
  }).done((data) => {
    $('#mm-contact-form-success').show()
    $('#mm-contact-form').hide()
  });
}

export default {
  mounted() {
    $('#mm-contact-form').submit(function(e) {
      handleFormData(e)
    });
  },
  methods: {},
  computed: {
    contactContent() {
      return this.$store.state.contactContent
    }
  },
  watch: {}
}
</script>

<style scoped>

  .footer-bar-contact-form {
    display: block;
    background: #fbfbfb;
    padding: 24px;
    font-family: 'Work Sans', sans-serif;
  }

  @media only screen and (max-width: 450px) {
    .footer-bar-contact-form {
      text-align: center;
    }
  }

  .mm-contact-form {
    margin-top: 48px;
  }

  .footer-bar-contact-form-text {
    display: block;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    padding: 6px 2px;
    font-size: 16px;
    width: 50%;
    color: black;
    font-weight: lighter;
    outline: none;
    margin: 0 auto;
    margin-bottom: 24px;
    background: none;
    font-family: 'Work Sans', sans-serif;
  }

  .footer-bar-contact-form-submit {
    display: block;
    -webkit-appearance: none;
    background: none;
    color: black;
    text-transform: uppercase;
    width: 50%;
    padding: 12px;
    margin: 24px auto;
    margin-top: 60px;
    border: 1px solid;
    cursor: pointer;
    font-size: 18px;
    transition: ease-in 0.125s;
    font-family: 'Work Sans', sans-serif;
  }

  .footer-bar-contact-form-submit:hover {
    background: black;
    color: white;
  }

  @media only screen and (max-width: 450px) {
    .footer-bar-contact-form-text,
    .footer-bar-contact-form-submit {
      width: 100%;
    }
  }

  .mm-contact-form-success {
    display: none;
    color: #00BFBD;
    font-size: 18px;
    width: 50%;
    text-align: center;
    margin: 24px auto;
    border: 3px solid;
    padding: 24px 12px;
  }

  @media only screen and (max-width: 450px) {
    .mm-contact-form-success,
    .footer-bar-contact-form-submit,
    .footer-bar-contact-form-text {
      width: 90%;
    }
  }
</style>



// WEBPACK FOOTER //
// ContactUs.vue?367e89e0